export default __webpack_public_path__ + "static/media/Toast.4ee4d213.svg";